var map = {
	"./da-DK-sw.json": "9307",
	"./da-DK.json": "08b2",
	"./en-US-sw.json": "7c9e",
	"./en-US.json": "3439",
	"./fi-FI-sw.json": "c529",
	"./fi-FI.json": "ffa4",
	"./nb-NO-sw.json": "2461",
	"./nb-NO.json": "f785",
	"./sv-SE-sw.json": "5ad8",
	"./sv-SE.json": "4dc9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "50cc";